import useId from '../utils/useId';
import * as React from 'react';
export const konbiniFamilymartSvg = React.forwardRef(
  function konbiniFamilymartSvgInner(props, ref) {
    const id_0 = useId();
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          clipPath: `url(#bi_konbini-familymart__a_${id_0})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          d: 'M0 0h32v32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 0h32v14H0V0Z',
          fill: '#009F41',
        }),
        /*#__PURE__*/ React.createElement('path', {
          d: 'M0 18h32v14H0V18Z',
          fill: '#008CD5',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'defs',
        null,
        /*#__PURE__*/ React.createElement(
          'clipPath',
          {
            id: `bi_konbini-familymart__a_${id_0}`,
          },
          /*#__PURE__*/ React.createElement('path', {
            fill: '#fff',
            d: 'M0 0h32v32H0z',
          }),
        ),
      ),
    );
  },
);
konbiniFamilymartSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbiniFamilymart = {
  category: 'brand',
  colorable: false,
  name: 'konbiniFamilymart',
  svg: konbiniFamilymartSvg,
};
